import { withErrorBoundary } from "@sentry/nextjs";
import { FC, ReactNode, useCallback, useState } from "react";
import { useDisclosureOrderTitles } from "hooks";
import { Disclosures } from "types";
import { DisclosuresContext } from "./DisclosuresContext";

interface Props {
  children: ReactNode;
}

const DisclosuresProvider: FC<Props> = withErrorBoundary(({ children }) => {
  const [disclosures, setDisclosures] = useState<Disclosures>({ data: [] });

  const handleUpdateDisclosures = useCallback(
    (disclosures: Disclosures) => setDisclosures(disclosures),
    [setDisclosures]
  );

  const { disclosureOrderTitles } = useDisclosureOrderTitles(disclosures);

  const disclosuresInCorrectOrder = disclosureOrderTitles.map((title) =>
    disclosures.data?.find((disclosure) => disclosure?.attributes.title.toLowerCase() === title?.toLowerCase())
  );

  return (
    <DisclosuresContext.Provider
      value={{
        disclosures,
        setDisclosures: handleUpdateDisclosures,
        disclosuresInCorrectOrder,
      }}
    >
      {children}
    </DisclosuresContext.Provider>
  );
}, {});

export { DisclosuresProvider };
